import { Fragment } from 'react';
import {
  EntityKindPicker,
  EntityLifecyclePicker,
  EntityNamespacePicker,
  EntityOwnerPicker,
  EntityProcessingStatusPicker,
  EntityTagPicker,
  EntityTypePicker,
} from '@backstage/plugin-catalog-react';
import { PsInfraScopePicker } from './PsInfraScopePicker';
import type { InfraScopeKind } from './EntityInfraScopeFilter';
import { InfraTypeCatalogFilter } from './InfraTypeCatalogFilter';
import { INFRA_TYPE_IMAGE_BUILD } from './catalogInfraTypes';

type PsCatalogFiltersProps = {
  initialKind?: string;
  initialScope?: InfraScopeKind;
  ownerPickerMode?: 'all' | 'owners-only';
  initiallySelectedNamespaces?: string[];
  excludeImageBuilds?: boolean;
};

export const PsCatalogFilters = ({
  initialKind = 'component',
  initialScope = 'my',
  ownerPickerMode,
  initiallySelectedNamespaces,
  excludeImageBuilds = false,
}: PsCatalogFiltersProps) => (
  <Fragment>
    {excludeImageBuilds ? (
      <InfraTypeCatalogFilter excludeTypes={[INFRA_TYPE_IMAGE_BUILD]} />
    ) : null}
    <EntityKindPicker initialFilter={initialKind} />
    <EntityTypePicker />
    <PsInfraScopePicker initialScope={initialScope} />
    <EntityOwnerPicker mode={ownerPickerMode} />
    <EntityLifecyclePicker />
    <EntityTagPicker />
    <EntityProcessingStatusPicker />
    <EntityNamespacePicker
      initiallySelectedNamespaces={initiallySelectedNamespaces}
    />
  </Fragment>
);
